export enum Labels {
    BPM = 'Pouls Périphériques',
    SPO2 = 'Saturation O2',
    TEMP = 'Température',
    WEIGHT = 'Poids',
    NIBP = 'Tension',
    GLYC = 'Glycémie capillaire',
    GLYC_2 = 'Glycemie capillaire',
    HEMATOCRITE = 'Hématocrite',
    KETONE = 'Cétone',
    URIC_ACID = 'Acide urique',
    CHOLESTEROL = 'Cholesterol',
    TRYGLICERIDE = 'Triglycérides',
    HEMOGLOBINE = 'HEMOGLOBINE',
    LACTATE = 'Lactate',
  }
  
  export interface Mesure {
    label: Labels
    value: string
    unit: string
  }